<!--
  @component
  A content divider with no line. It can be flexible.
-->
<script>
  /**
   * @typedef {object} Props
   * @property {string} [class] The `class` attribute on the wrapper element.
   * @property {boolean} [flex] Whether to make the spacer flexible.
   */

  /**
   * @type {Props & Record<string, any>}
   */
  let {
    /* eslint-disable prefer-const */
    class: className,
    flex = false,
    ...restProps
    /* eslint-enable prefer-const */
  } = $props();
</script>

<div {...restProps} role="none" class="sui spacer {className}" class:flex></div>

<style>.spacer.flex:not([hidden]) {
  display: block;
  flex: auto;
}
.spacer:not(.flex) {
  width: 8px;
  height: 8px;
}</style>
